<p-panel>
    <h4>Datos del producto</h4>
    <div class="row">
        <app-reactive-form-builder
                #formbuilder
                (formChanges)="formChanges($event[0], $event[1])"
                (goBack)="goBack()"
                (afterSend)="undefined"
                [form]="form.formFields"
                [serverUrl]="''"
                [dropdownLoadTrigger]="dropdownLoadTrigger"
                [previousData]="getModel()"
                [request]="this.getType() === 1 ? this.productosApi.productos.PUT : this.productosApi.productos.POST"
                [getRequest]="this.productosApi.productos.GET">
        </app-reactive-form-builder>
    </div>
    <br>
</p-panel>
<br>
<p-panel *ngIf="getType() === formTypes.CREATE">
    <app-common-list-table [request]="formApi.productosVademecum" [hideSearch]="true" (rowClick)="productSelected($event);"
        [cols]="form.cols" [globalConditionalStyle]="globalConditionalStyle" [globalVisualTransform]="globalVisualTransform" [searchValue]="searchValue">

        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Ficha Técnica</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td>
                <a *ngIf="data.data"
                    [href]="'https://fichas-oficiales.s3.eu-west-3.amazonaws.com/' + data.data.referencia.trim() + '.pdf'"
                    target="_blank">
                    <button class="btn btn-primary">
                        <span class="fa fa-file" style="margin-right: 10px"></span>
                        Ficha
                    </button>
                    <!-- Notification -->
                    <div *ngIf="form.env.showInfoCambios && data.data.codigo_actualizacion"
                        class="d-flex justify-content-center align-items-center" style="
                            background-color: red;
                            height: 15px;
                            width: 15px;
                            position: relative;
                            top: -36px;
                            left: 68px;
                            border: 1px inset white;
                            border-radius: 50%;
                            color: white;
                            font-size: xx-small;">
                        <span>!</span>
                    </div>
                </a>
            </td>
        </ng-template>

    </app-common-list-table>
</p-panel>
<br>
<p-dialog [(visible)]="form.openDialog" [modal]="true" [style]="{ width: '70vw' }"
          [closable]="true" [dismissableMask]="true"
          [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
          header="Información Producto {{ form.lists.productos.selected?.nombre }}">
  
  <table class="table table-striped table-bordered w-100">
    <thead>
      <tr style="font-size: 0.85rem; text-align: center;">
        <th>Producto</th>
        <th>Fecha de Caducidad</th>
        <th>Materia Activa</th>
        <th>Condiciones de uso</th>
      </tr>
    </thead>
    <tbody  style="font-size: 0.75rem;">
      <tr>
        <td style="width: 20vw; text-align: center;">{{ form.lists.productos.selected?.nombre_comercial }}</td>
        <td style="width: 10vw; text-align: center;">{{ fecha_caducidad }}</td>
        <td style="width: 20vw; text-align: center;">{{ form.model.materia_activa }}</td>
        <td style="width: 40vw; text-align: center;">{{ form.lists.productos.selected?.condiciones_uso }}</td>
      </tr>
    </tbody>
  </table>

  <ng-template pTemplate="footer">
    <div class="text-center w-100">
      <p-button label="Cerrar" (click)="form.openDialog = false"></p-button>
    </div>
  </ng-template>

</p-dialog>
